module.exports = __webpack_public_path__ + "img/disconnected.87abc729.svg";